import type { MomentButton } from "../../data/momentOptions";

type Props = {
  buttons: { id: string; title: string }[];
  shareFlag?: boolean;
};

export default function ButtonsRow({ buttons, shareFlag }: Props) {
  const totalBtns = buttons.length + (shareFlag ? 1 : 0);
  if (totalBtns === 0) return null;
  const isRow = totalBtns >= 2;

  return (
    <div className={`tw-px-4 tw-pb-3 ${isRow ? "tw-flex tw-gap-1.5" : "tw-space-y-1.5"}`}>
      {buttons.map((btn) => (
        <div
          key={btn.id}
          className={`${isRow ? "tw-flex-1" : "tw-w-full"} tw-bg-gray-50 tw-border tw-border-gray-200 tw-rounded-md tw-py-2 tw-text-[12px] tw-font-semibold tw-text-gray-700 tw-text-center`}
        >
          {btn.title}
        </div>
      ))}
      {shareFlag && (
        <div className={`${isRow ? "tw-flex-1" : "tw-w-full"} tw-bg-gray-50 tw-border tw-border-gray-200 tw-rounded-md tw-py-2 tw-text-[12px] tw-font-semibold tw-text-gray-500 tw-text-center`}>
          공유하기
        </div>
      )}
    </div>
  );
}
